export enum MortgageDocumentType {
  credit_line_mortgage = 'credit_line_mortgage',
  deed_of_trust = 'deed_of_trust',
  mortgage = 'mortgage',
  security_deed = 'security_deed',
  other = 'other',
}
